import { useState } from "react";
import styles from "./EditChild.module.css";
import childrenStyles from "../../pages/css/Children.module.css";
import { EditChildProps, ChildFormData } from "../../types/child.types";

export const EditChildForm = ({ child, onCancel, onSave }: EditChildProps) => {
  const [formData, setFormData] = useState<ChildFormData>({
    fname: child.fname || "",
    lname: child.lname || "",
    birthday: child.birthday?.slice(0, 10) || "", 
    gender: child.gender || "",
    email: child.email || "",
    address: child.address || "",
    lessonNumber: child.lessonNumber || 0,
    childsDisability: child.childsDisability || "",
    familyPosition: child.familyPosition || "",
    educationalInstitution: child.educationalInstitution || ""
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({ ...child, ...formData });
  };

  return (
    <form onSubmit={handleSubmit} className={styles.editForm}>
      <button 
        type="button" 
        className={styles.closeButton} 
        onClick={onCancel}
        aria-label="סגור"
      >
        ×
      </button>
        <div className={childrenStyles.formGroup} style={{ 
          opacity: '0.7', 
          fontSize: '0.95em',
          backgroundColor: '#f9f9f9',
          padding: '12px 15px',
          borderRadius: '12px',
          gridColumn: '1 / -1'
        }}>
          <label htmlFor="childId" style={{
            fontWeight: 'bold',
            color: '#471f1f',
            marginBottom: '8px',
            display: 'block'
          }}>תעודת זהות:</label>
          <div className={childrenStyles.input} style={{
            backgroundColor: '#f0f0f0', 
            color: '#666',
            padding: '12px 15px',
            borderRadius: '10px',
            border: '1px solid #e0e0e0',
            fontSize: '1.05rem'
          }}>{child.id}</div>
        </div>

        <div className={childrenStyles.formGroup}>
          <label htmlFor="fname" style={{
            fontWeight: 'bold',
            color: '#471f1f',
            marginBottom: '8px',
            display: 'block'
          }}>שם פרטי:</label>
          <input 
            id="fname"
            name="fname" 
            value={formData.fname} 
            onChange={handleChange} 
            required 
            className={childrenStyles.input}
            style={{
              padding: '12px 15px',
              borderRadius: '10px',
              border: '1px solid #e0e0e0',
              fontSize: '1.05rem',
              width: '100%',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        <div className={childrenStyles.formGroup}>
          <label htmlFor="lname" style={{
            fontWeight: 'bold',
            color: '#471f1f',
            marginBottom: '8px',
            display: 'block'
          }}>שם משפחה:</label>
          <input 
            id="lname"
            name="lname" 
            value={formData.lname} 
            onChange={handleChange} 
            required 
            className={childrenStyles.input}
            style={{
              padding: '12px 15px',
              borderRadius: '10px',
              border: '1px solid #e0e0e0',
              fontSize: '1.05rem',
              width: '100%',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        <div className={childrenStyles.formGroup}>
          <label htmlFor="birthday" style={{
            fontWeight: 'bold',
            color: '#471f1f',
            marginBottom: '8px',
            display: 'block'
          }}>תאריך לידה:</label>
          <input 
            id="birthday"
            type="date" 
            name="birthday" 
            value={formData.birthday} 
            onChange={handleChange} 
            required 
            className={childrenStyles.input}
            style={{
              padding: '12px 15px',
              borderRadius: '10px',
              border: '1px solid #e0e0e0',
              fontSize: '1.05rem',
              width: '100%',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        <div className={childrenStyles.formGroup}>
          <label htmlFor="gender" style={{
            fontWeight: 'bold',
            color: '#471f1f',
            marginBottom: '8px',
            display: 'block'
          }}>מין:</label>
          <input 
            id="gender"
            name="gender" 
            value={formData.gender} 
            onChange={handleChange} 
            className={childrenStyles.input}
            style={{
              padding: '12px 15px',
              borderRadius: '10px',
              border: '1px solid #e0e0e0',
              fontSize: '1.05rem',
              width: '100%',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        <div className={childrenStyles.formGroup}>
          <label htmlFor="email" style={{
            fontWeight: 'bold',
            color: '#471f1f',
            marginBottom: '8px',
            display: 'block'
          }}>אימייל:</label>
          <input 
            id="email"
            name="email" 
            value={formData.email} 
            onChange={handleChange} 
            className={childrenStyles.input}
            style={{
              padding: '12px 15px',
              borderRadius: '10px',
              border: '1px solid #e0e0e0',
              fontSize: '1.05rem',
              width: '100%',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        <div className={childrenStyles.formGroup}>
          <label htmlFor="address" style={{
            fontWeight: 'bold',
            color: '#471f1f',
            marginBottom: '8px',
            display: 'block'
          }}>כתובת:</label>
          <input 
            id="address"
            name="address" 
            value={formData.address} 
            onChange={handleChange} 
            className={childrenStyles.input}
            style={{
              padding: '12px 15px',
              borderRadius: '10px',
              border: '1px solid #e0e0e0',
              fontSize: '1.05rem',
              width: '100%',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        <div className={childrenStyles.formGroup}>
          <label htmlFor="lessonNumber" style={{
            fontWeight: 'bold',
            color: '#471f1f',
            marginBottom: '8px',
            display: 'block'
          }}>מספר שיעור:</label>
          <input 
            id="lessonNumber"
            type="number" 
            name="lessonNumber" 
            value={formData.lessonNumber} 
            onChange={handleChange} 
            className={childrenStyles.input}
            style={{
              padding: '12px 15px',
              borderRadius: '10px',
              border: '1px solid #e0e0e0',
              fontSize: '1.05rem',
              width: '100%',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        <div className={childrenStyles.formGroup}>
          <label htmlFor="childsDisability" style={{
            fontWeight: 'bold',
            color: '#471f1f',
            marginBottom: '8px',
            display: 'block'
          }}>לקות הילד:</label>
          <input 
            id="childsDisability"
            name="childsDisability" 
            value={formData.childsDisability} 
            onChange={handleChange} 
            className={childrenStyles.input}
            style={{
              padding: '12px 15px',
              borderRadius: '10px',
              border: '1px solid #e0e0e0',
              fontSize: '1.05rem',
              width: '100%',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        <div className={childrenStyles.formGroup}>
          <label htmlFor="familyPosition" style={{
            fontWeight: 'bold',
            color: '#471f1f',
            marginBottom: '8px',
            display: 'block'
          }}>מיקום במשפחה:</label>
          <input 
            id="familyPosition"
            name="familyPosition" 
            value={formData.familyPosition} 
            onChange={handleChange} 
            className={childrenStyles.input}
            style={{
              padding: '12px 15px',
              borderRadius: '10px',
              border: '1px solid #e0e0e0',
              fontSize: '1.05rem',
              width: '100%',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        <div className={childrenStyles.formGroup}>
          <label htmlFor="educationalInstitution" style={{
            fontWeight: 'bold',
            color: '#471f1f',
            marginBottom: '8px',
            display: 'block'
          }}>מוסד לימודים:</label>
          <input 
            id="educationalInstitution"
            name="educationalInstitution" 
            value={formData.educationalInstitution} 
            onChange={handleChange} 
            className={childrenStyles.input}
            style={{
              padding: '12px 15px',
              borderRadius: '10px',
              border: '1px solid #e0e0e0',
              fontSize: '1.05rem',
              width: '100%',
              transition: 'all 0.3s ease'
            }}
          />
        </div>

        <div className={childrenStyles.buttonContainer} style={{
          marginTop: '30px',
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
          gridColumn: '1 / -1'
        }}>
          <button 
            type="submit" 
            className={childrenStyles.button}
            style={{
              padding: '12px 35px',
              fontSize: '1.05rem',
              backgroundColor: '#a2b087',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}
          >
            שמור שינויים
          </button>
        </div>
      </form>
  );
};
